import { useState } from 'react';
import { Form, Input, Segment, Message } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import useLocalStorage from '../../../libs/useLocalStorage';
import Center from '../../../components/Auth/Center';
import CenterWidth from '../../../components/Auth/CenterWidth';
import HeaderName from '../../../components/Auth/HeaderName';
import CenterMessage from '../../../components/CenterMessage';
import ButtonStretch from '../../../components/ButtonStretch';
import { api_url } from '../../../config';

function PasswordReset() {
	const [ jwt_token, setJwtToken ]       = useLocalStorage(`jwt_token`);
	const [ , setUser ]                    = useLocalStorage(`user`);
	const [ saving, setSaving ]            = useState(false);
	const [ error, setError ]              = useState(false);
	const [ sent_message, setSentMessage ] = useState(false);
	const [ passwords, setPasswords ]      = useState({});
	const search                           = useLocation().search;
	const token                            = new URLSearchParams(search).get(`token`);

	if(jwt_token) {
		window.location = `/`;
	}

	function handleInput(e) {
		setPasswords({ ...passwords, ...{ [e.target.name] : e.target.value }});
	}

	function handleSubmit() {
		setSentMessage(false);
		setError(false);

		if(!passwords.password1 || !passwords.password2) {
			setError(`Passwords can't be empty`);

			return;
		}

		if(passwords.password1 !== passwords.password2) {
			setError(`Passwords do not match`);

			return;
		}

		if(passwords.password1.length < 7) {
			setError(`Password must be at least 7 characters long`);

			return;
		}

		setSaving(true);

		fetch(`${api_url}/reset_password`, {
			method : `POST`,
			body   : JSON.stringify({ token, password : passwords.password1 }),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(response => {
			setSaving(false);

			if(response.error || !response.jwt) {
				setError(response.error);

				return;
			}

			setSentMessage(true);

			setTimeout(() => {
				// Redirect to the home page
				const decoded = jwt_decode(response.jwt);

				setJwtToken(response.jwt);
				setUser(decoded.sub.user);
			}, 2500)
		});
	}

	return (
		<Center>
			<CenterWidth>
				<HeaderName />
				{!sent_message &&
					<Message info>Please enter a new password</Message>
				}

				{sent_message &&
					<Message positive>Your password has been reset. You are now being redirected.</Message>
				}

				<Segment>
					<Form>
						<Form.Field>
							<label>New Password</label>
							<Input name="password1" type="password" onChange={handleInput} />
						</Form.Field>

						<Form.Field>
							<label>Confirm Password</label>
							<Input name="password2" type="password" onChange={handleInput} />
						</Form.Field>

						<ButtonStretch loading={saving} positive onClick={handleSubmit}>Submit</ButtonStretch>
					</Form>
					{error &&
						<CenterMessage negative>
							<p>{error}</p>
						</CenterMessage>
					}
				</Segment>
			</CenterWidth>
		</Center>
	);
}

export default PasswordReset;
